import { createStyles, makeStyles } from '@material-ui/core'

export const useCreateSelectModalStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '262px 0',
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        margin: '208px 0'
      },
      [theme.breakpoints.down('xs')]: {
        margin: '159px 0'
      }
    },
    modalContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: 20,
      [theme.breakpoints.down('sm')]: {
        gap: 35
      }
    },
    title: {
      textAlign: 'center',
      fontFamily: 'Montserrat',
      fontSize: 24,
      lineHeight: '28px',
      color: '#212121',
      [theme.breakpoints.down('sm')]: {
        fontSize: 20,
        lineHeight: '23px'
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: 18,
        lineHeight: '21px'
      }
    },
    buttons: {
      display: 'flex',
      justifyContent: 'center',
      gap: 38,
      [theme.breakpoints.down('sm')]: {
        alignItems: 'center',
        flexDirection: 'column',
        gap: 25
      }
    },
    firstBtn: {
      width: 270,
      textTransform: 'none',
      [theme.breakpoints.down('sm')]: {
        fontSize: 12,
        maxWidth: 246,
        letterSpacing: '1.25px',
        padding: '12px 2px'
      }
    },
    secondBtn: {
      width: 270,
      textTransform: 'none',
      border: '2px solid #2E86BD',
      color: '#212121',
      '&:hover': {
        border: '2px solid #2E86BD'
      },
      [theme.breakpoints.down('sm')]: {
        maxWidth: 246,
        letterSpacing: '1.25px',
        padding: '8px 2px'
      }
    }
  })
)
